import { useState } from "react";
import { PubDialog } from "./Fichas";

const CHARLAS = [
  ["afrontamiento", "Técnicas de afrontamiento", "1PPivZjyTjOrwaIXwngRNnLtLgBLkL2QE", "Estrategias para enfrentar la presión, los errores y la frustración en el deporte.", "#2D6DB4"],
  ["regulacion", "Regulación emocional", "1-vHy2nEAkh_VKhE9RiJW5MfuWuueDn37", "Cómo reconocer y manejar las emociones antes, durante y después de competir.", "#EB8200"],
  ["comunicacion", "Comunicación asertiva", "1kFg-fgTwYipmH9dhwDs3nXLEMzAb2lWs", "Expresar lo que pienso y siento con respeto, dentro y fuera de la cancha.", "#F6A70B"],
  ["empatia", "Empatía", "1yJP2M5gcWJhhRBtWoVVmb50lW6c2mIwm", "Ponerse en el lugar del compañero para construir un mejor equipo.", "#4E4D4D"],
];

const Thumb = ({ n, color }) => (
  <div className="cthumb" style={{ background: `linear-gradient(160deg, ${color}, #1E4F87)` }} aria-hidden="true">
    <span className="cnum">0{n}</span>
    <span className="cplay"><svg width="22" height="22" viewBox="0 0 22 22"><path d="M7 4.5v13l11-6.5z" fill="#3A3939" /></svg></span>
  </div>
);

export const Charlas = () => {
  const [open, setOpen] = useState(null);
  const c = open !== null ? CHARLAS[open] : null;
  return (
    <div data-testid="charlas-block">
      <h3 style={{ marginTop: 40 }}>Charlas Once y Once</h3>
      <p className="note" style={{ margin: "6px 0 0" }}>Videos de la fundación sobre las habilidades que entrenamos con nuestros deportistas.</p>
      <div className="figrid" data-testid="charlas-grid">
        {CHARLAS.map(([id, t, , d, color], i) => (
          <button className="fcard" key={id} onClick={() => setOpen(i)} data-testid={`charla-card-${id}`}>
            <Thumb n={i + 1} color={color} />
            <div><small>Charla · Video</small><h4>{t}</h4><p>{d}</p><span className="ftag">▶ Ver charla</span></div>
          </button>
        ))}
      </div>
      {c && (
        <PubDialog onClose={() => setOpen(null)} testid="charla-dialog">
          <small style={{ color: "var(--sol-l)", fontWeight: 800 }}>CHARLAS ONCE Y ONCE</small>
          <h3 style={{ margin: "4px 0 6px" }} data-testid="charla-dialog-title">{c[1]}</h3>
          <p style={{ color: "#EAF1FA" }}>{c[3]}</p>
          <div className="vframe">
            <iframe src={`https://drive.google.com/file/d/${c[2]}/preview`} title={c[1]} allow="autoplay; fullscreen" allowFullScreen loading="lazy" data-testid="charla-iframe" />
          </div>
        </PubDialog>
      )}
    </div>
  );
};
